// extracted by mini-css-extract-plugin
export default {"dialog":"dialog--D5khw","size_default":"size_default--ubWzS","size_wysiwyg":"size_wysiwyg--v7xQy","size_maxcontent":"size_maxcontent--YVyE0"};